<template>
  <div v-show="!isEdit" :class="componentClassName">
    <a-page-heading id="addPageHeadingTitle">連絡先</a-page-heading>
    <m-section variant="fullpage">
      <m-action-card
        id="phoneBookAdd"
        title="新規登録"
        no-header-margin
        :header-border="true"
        icon="user"
        :narrow-body="true"
      >
        <form class="t-phone-book-add-one-by-one__form" @submit.prevent="handleFormSubmit">
          <div class="t-phone-book-add-one-by-one__row">
            <div class="t-phone-book-add-one-by-one__col">
              <m-form-input error label="姓(必須)">
                <a-text-field
                  id="lastName"
                  v-model="formData.last_name"
                  type="text"
                  name=""
                  placeholder="山田"
                  maxlength="20"
                  required
                />
              </m-form-input>
            </div>
            <div class="t-phone-book-add-one-by-one__col">
              <m-form-input label="名(必須)">
                <a-text-field
                  id="name"
                  v-model="formData.first_name"
                  type="text"
                  name=""
                  placeholder="太郎"
                  maxlength="20"
                  required
                />
              </m-form-input>
            </div>
          </div>
          <div class="t-phone-book-add-one-by-one__row">
            <div class="t-phone-book-add-one-by-one__col">
              <m-form-input label="フリガナ（姓）(必須)">
                <a-text-field
                  id="lastNameKana"
                  v-model="formData.furigana_last_name"
                  type="text"
                  name=""
                  placeholder="ヤマダ"
                  pattern="[ァ-ヺー0-9０-９A-Za-z]+"
                  maxlength="40"
                  required
                />
              </m-form-input>
            </div>
            <div class="t-phone-book-add-one-by-one__col">
              <m-form-input label="フリガナ（名）(必須)">
                <a-text-field
                  id="nameKana"
                  v-model="formData.furigana_first_name"
                  type="text"
                  name=""
                  placeholder="タロウ"
                  pattern="[ァ-ヺー0-9０-９A-Za-z]+"
                  maxlength="40"
                  required
                />
              </m-form-input>
            </div>
          </div>
          <div class="t-phone-book-add-one-by-one__row">
            <m-form-input label="電話番号(必須)">
              <a-text-field
                id="phoneNumber"
                v-model="formData.phone_number"
                type="tel"
                name=""
                placeholder="ハイフンなし"
                maxlength="11"
                pattern="[0-9]{10,11}"
                required
              />
            </m-form-input>
          </div>

          <div class="t-phone-book-add-one-by-one__row">
            <m-form-input label="メールアドレス">
              <a-text-field id="mail" v-model="formData.mail" type="mail" name="" placeholder="" maxlength="50" />
            </m-form-input>
          </div>
          <div class="t-phone-book-add-one-by-one__row">
            <m-form-input label="会社名">
              <a-text-field
                id="companyName"
                v-model="formData.companyName"
                type="text"
                name=""
                placeholder=""
                maxlength="80"
              />
            </m-form-input>
          </div>
          <div class="t-phone-book-add-one-by-one__row">
            <m-form-input label="部署名">
              <a-text-field
                id="departmentName"
                v-model="formData.departmentName"
                type="text"
                name=""
                placeholder=""
                maxlength="40"
              />
            </m-form-input>
          </div>
          <div class="t-phone-book-add-one-by-one__row">
            <m-form-input label="住所">
              <a-text-field
                id="address"
                v-model="formData.address"
                type="text"
                name=""
                placeholder=""
                maxlength="160"
              />
            </m-form-input>
          </div>
          <div class="t-phone-book-add-one-by-one__row">
            <m-form-input label="メモ">
              <textarea
                id="memo"
                v-model="formData.memo"
                class="a-text-field__input"
                placeholder=""
                maxlength="200"
              ></textarea>
            </m-form-input>
          </div>
          <!--
          <div class="t-phone-book-add-one-by-one__row">
            <m-form-input label="メモ">
              <a-text-field
                v-model="formData.memo"
                type="textarea"
                name=""
                placeholder=""
                maxlength="100"
              />
            </m-form-input>
          </div>
-->
          <m-form-action-buttons>
            <a-button
              id="registButton"
              variant="block"
              color="primary"
              submit="submit"
              :disabled="!flagRegistButtonEnable"
            >
              登録
            </a-button>
            <a-button id="registPageCancelButton" variant="outlined" color="primary" @click="handleCancelClick">
              キャンセル
            </a-button>
          </m-form-action-buttons>
        </form>
      </m-action-card>
    </m-section>
  </div>

  <!-- 編集用 -->
  <div v-show="isEdit" :class="componentClassName">
    <a-page-heading id="editPageHeadingTitle">連絡先</a-page-heading>
    <m-section variant="fullpage">
      <m-action-card
        id="phoneBookEdit"
        title="編集"
        no-header-margin
        :header-border="true"
        icon="user"
        :narrow-body="true"
      >
        <form class="t-phone-book-add-one-by-one__form" @submit.prevent="handleFormSubmit">
          <div class="t-phone-book-add-one-by-one__row">
            <div class="t-phone-book-add-one-by-one__col">
              <m-form-input error label="姓(必須)">
                <a-text-field
                  id="lastName"
                  v-model="formData.last_name"
                  type="text"
                  name=""
                  placeholder="山田"
                  maxlength="20"
                  required
                />
              </m-form-input>
            </div>
            <div class="t-phone-book-add-one-by-one__col">
              <m-form-input label="名(必須)">
                <a-text-field
                  id="name"
                  v-model="formData.first_name"
                  type="text"
                  name=""
                  placeholder="太郎"
                  maxlength="20"
                  required
                />
              </m-form-input>
            </div>
          </div>
          <div class="t-phone-book-add-one-by-one__row">
            <div class="t-phone-book-add-one-by-one__col">
              <m-form-input label="フリガナ（姓）(必須)">
                <a-text-field
                  id="lastNameKana"
                  v-model="formData.furigana_last_name"
                  type="text"
                  name=""
                  placeholder="ヤマダ"
                  pattern="[ァ-ヺー0-9０-９A-Za-z]+"
                  maxlength="40"
                  required
                />
              </m-form-input>
            </div>
            <div class="t-phone-book-add-one-by-one__col">
              <m-form-input label="フリガナ（名）(必須)">
                <a-text-field
                  id="nameKana"
                  v-model="formData.furigana_first_name"
                  type="text"
                  name=""
                  placeholder="タロウ"
                  pattern="[ァ-ヺー0-9０-９A-Za-z]+"
                  maxlength="40"
                  required
                />
              </m-form-input>
            </div>
          </div>
          <div class="t-phone-book-add-one-by-one__row">
            <m-form-input label="電話番号(必須)">
              <a-text-field
                id="phoneNumber"
                v-model="formData.phone_number"
                type="tel"
                name=""
                placeholder="ハイフンなし"
                maxlength="11"
                pattern="[0-9]{10,11}"
                required
              />
            </m-form-input>
          </div>

          <div class="t-phone-book-add-one-by-one__row">
            <m-form-input label="メールアドレス">
              <a-text-field id="mail" v-model="formData.mail" type="mail" name="" placeholder="" maxlength="50" />
            </m-form-input>
          </div>
          <div class="t-phone-book-add-one-by-one__row">
            <m-form-input label="会社名">
              <a-text-field
                id="companyName"
                v-model="formData.companyName"
                type="text"
                name=""
                placeholder=""
                maxlength="80"
              />
            </m-form-input>
          </div>
          <div class="t-phone-book-add-one-by-one__row">
            <m-form-input label="部署名">
              <a-text-field
                id="departmentName"
                v-model="formData.departmentName"
                type="text"
                name=""
                placeholder=""
                maxlength="40"
              />
            </m-form-input>
          </div>
          <div class="t-phone-book-add-one-by-one__row">
            <m-form-input label="住所">
              <a-text-field
                id="address"
                v-model="formData.address"
                type="text"
                name=""
                placeholder=""
                maxlength="160"
              />
            </m-form-input>
          </div>
          <div class="t-phone-book-add-one-by-one__row">
            <m-form-input label="メモ">
              <textarea
                id="memo"
                v-model="formData.memo"
                class="a-text-field__input"
                placeholder=""
                maxlength="200"
              ></textarea>
            </m-form-input>
          </div>
          <!--
          <div class="t-phone-book-add-one-by-one__row">
            <m-form-input label="メモ">
              <a-text-field
                v-model="formData.memo"
                type="textarea"
                name=""
                placeholder=""
                maxlength="100"
              />
            </m-form-input>
          </div>
-->
          <m-form-action-buttons>
            <a-button id="saveBtn" variant="block" color="primary" submit="submit" :disabled="!flagRegistButtonEnable">
              保存
            </a-button>
            <a-button id="editPageCancelBtn" variant="outlined" color="primary" @click="handleCancelClick">
              キャンセル
            </a-button>
          </m-form-action-buttons>
        </form>
      </m-action-card>
    </m-section>
  </div>

  <teleport to="body">
    <o-modal
      id="phoneBookAddOne_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="dialogOkButton"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleCloseModal"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import APageHeading from '@/components/atoms/page-heading';
import ATextField from '@/components/atoms/text-field';
import MActionCard from '@/components/molecules/action-card';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import MFormInput from '@/components/molecules/form-input';
import MSection from '@/components/molecules/section';
import OModal from '@/components/organisms/modal';
import { cloneDeep } from 'lodash';

import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';
import { PERMISSIONS_FRONTEND } from '@/libs/constants';
import { POINT } from '@/libs/constants';

import { customValidate } from '@/common/customValidate.js'; // #2371

export default {
  name: 't-phone-book-add-one-by-one',
  components: {
    AButton,
    APageHeading,
    ATextField,
    MActionCard,
    MFormActionButtons,
    MFormInput,
    MSection,
    OModal,
  },
  mixins: [messageContent, customRequest, customValidate], // #2371

  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
    // currentData: {
    //   type: Object,
    //   default: null,
    // },
    // handleSaveClick: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      formData: {
        last_name: '',
        first_name: '',
        furigana_last_name: '',
        furigana_first_name: '',
        phone_number: '',
        mail: '',
        companyName: '',
        departmentName: '',
        address: '',
        memo: '',
      },
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      isEdit: false,
      fromHistoryDetails: false,
      contactID: '',
      selectedCompanyID: '',
      flagRegistButtonEnable: true, //#1892
      // #2371 特殊記号チェック対象項目のリスト
      spCharCheckList: [
        {
          name: '姓',
          fieldName: 'last_name',
        },
        {
          name: '名',
          fieldName: 'first_name',
        },
        {
          name: 'フリガナ（姓）',
          fieldName: 'furigana_last_name',
        },
        {
          name: 'フリガナ（名）',
          fieldName: 'furigana_first_name',
        },
        {
          name: '電話番号',
          fieldName: 'phone_number',
        },
        {
          name: 'メールアドレス',
          fieldName: 'mail',
        },
        {
          name: '会社名',
          fieldName: 'companyName',
        },
        {
          name: '部署名',
          fieldName: 'departmentName',
        },
        {
          name: '住所',
          fieldName: 'address',
        },
        {
          name: 'メモ',
          fieldName: 'memo',
        },
      ],
      sendData: {},
      routingAfterCloseModalFlag: false,
      authInfo: this.$store.state.user.authInfo,
      POINT,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-phone-book-add-one-by-one');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created() {
    if (this.$route.query.companyID) {
      this.selectedCompanyID = this.$route.query.companyID;
    } else {
      this.selectedCompanyID = this.companyID;
    }
  },
  mounted() {
    // 企業の管理者(マスタ含)または003300以外のオペレータのみ実行可
    if (
      PERMISSIONS_FRONTEND['phoneDataEditing'][this.authInfo] ||
      (this.companyID !== POINT && this.authInfo === 'operator')
    ) {
      this.contactID = this.$route.query.contactID;
      this.fromHistoryDetails = this.$route.query.fromHistoryDetails ?? false;
      this.flagRegistButtonEnable = true; //#1892
      if (this.contactID) {
        this.isEdit = true;
        this.fetchContactDataHandler(this.contactID);
      } else {
        this.isEdit = false;
      }
    } else {
      this.$router.push({ path: '/permission-denied' });
    }
  },
  methods: {
    setCurrentValue(val) {
      if (!val.name) {
        this.formData.last_name = '';
        this.formData.first_name = '';
      } else {
        this.name = val.name.split('_');
        this.formData.last_name = this.name[0] || '';
        this.formData.first_name = this.name[1] || '';
      }

      if (!val.nameKana) {
        this.formData.furigana_last_name = '';
        this.formData.furigana_first_name = '';
      } else {
        this.nameKana = val.nameKana.split('_');
        this.formData.furigana_last_name = this.nameKana[0] || '';
        this.formData.furigana_first_name = this.nameKana[1] || '';
      }
      this.formData.phone_number = val.key || '';
      this.formData.mail = val.mail || '';
      this.formData.companyName = val.companyName || '';
      this.formData.departmentName = val.departmentName || '';
      this.formData.address = val.address || '';
      this.formData.memo = val.memo || '';
    },
    handleFormSubmit(e) {
      this.flagRegistButtonEnable = false; //#1892
      e.preventDefault();
      this.handleSaveClick(cloneDeep(this.formData));
    },
    handleSaveClick() {
      this.sendData = {
        first_name: this.formData.first_name.replace(/\t/g, ''),
        last_name: this.formData.last_name.replace(/\t/g, ''),
        furigana_first_name: this.formData.furigana_first_name.replace(/\t/g, ''),
        furigana_last_name: this.formData.furigana_last_name.replace(/\t/g, ''),
        phone_number: this.formData.phone_number.replace(/\t/g, ''),
        mail: this.formData.mail.replace(/\t/g, ''),
        companyName: this.formData.companyName.replace(/\t/g, ''),
        departmentName: this.formData.departmentName.replace(/\t/g, ''),
        address: this.formData.address.replace(/\t/g, ''),
        memo: this.formData.memo.replace(/\t/g, '').replace(/\n/g, '%%n%%'), // #2138
      };

      // #2371 特殊記号チェックを追加
      for (const item of this.spCharCheckList) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.sendData[item.fieldName] })) {
          this.showErrorModal(messageContent.requireNotSpecialCharacter(item.name));
          this.flagRegistButtonEnable = true; //#1892
          return;
        }
        // #3056 4B文字チェックを追加
        const eChar = this.with4BCode(this.sendData[item.fieldName]);
        if (eChar !== '') {
          this.showErrorModal(messageContent.requireNot4BCharacter(item.name, eChar));
          this.flagRegistButtonEnable = true; //#1892
          return;
        }
      }
      if (!this.isEdit) {
        this.postRequest('/contactlist/insert', { sendData: this.sendData, companyID: this.selectedCompanyID })
          .then(e => {
            if (e.session) {
              if (e.msg) {
                this.showErrorModal(e.msg);
                this.flagRegistButtonEnable = true; //#1892
              } else {
                this.contactList = e.data;
                this.routingAfterCloseModalFlag = true;
                this.showInfoModal(messageContent.notifyPhoneBookAdd());
              }
            } else {
              window.location.href = '/login';
            }
          })
          .catch(err => {
            console.log(err);
            this.showErrorModal(messageContent.requireTry('連絡先登録'));
            this.flagRegistButtonEnable = true; //#1892
          });
      } else if (this.isEdit) {
        this.postRequest('/contactlist/update', {
          sendData: this.sendData,
          contactID: this.$route.query.contactID,
          companyID: this.selectedCompanyID,
        })
          .then(e => {
            if (e.session) {
              if (e.msg) {
                this.showErrorModal(e.msg);
                this.flagRegistButtonEnable = true; //#1892
              } else {
                this.contactList = e.data;
                this.routingAfterCloseModalFlag = true;
                this.showInfoModal(messageContent.notifyPhoneBookSaved());
              }
            } else {
              window.location.href = '/login';
            }
          })
          .catch(err => {
            console.log(err);
            this.showErrorModal(messageContent.requireTry('連絡先更新'));
            this.flagRegistButtonEnable = true; //#1892
          });
      }
    },
    handleCancelClick(e) {
      if (!this.isEdit) {
        this.$router.push({
          path: '/contactlist',
          query: {
            wordFlag: this.$route.query.wordFlag,
            searchFormType: this.$route.query.searchFormType,
            companyID: this.selectedCompanyID,
          },
        }); // #2121
      } else if (this.isEdit) {
        if (this.fromHistoryDetails) {
          this.$router.push({
            path: '/historydetail',
            query: {
              CallSid: this.$route.query.CallSid,
              search_phonebook_name: this.$route.query.search_phonebook_name,
              search_agent_name: this.$route.query.search_agent_name,
              search_memo: this.$route.query.search_memo,
              start: this.$route.query.start,
              end: this.$route.query.end,
              type: this.$route.query.type,
              page: this.$route.query.page,
              search_phone_number: this.$route.query.search_phone_number,
              status: this.$route.query.status,
              agent_name: this.$route.query.agent_name,
            },
          });
        } else {
          this.$router.push({
            path: '/contactlist/detail',
            query: {
              contactID: this.$route.query.contactID,
              wordFlag: this.$route.query.wordFlag,
              searchFormType: this.$route.query.searchFormType,
              companyID: this.selectedCompanyID,
            },
          }); // #2121
        }
      }
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      // 連絡先登録or編集後の場合は、画面遷移
      if (this.routingAfterCloseModalFlag) {
        if (!this.isEdit) {
          this.$router.push({
            path: '/contactlist',
            query: {
              wordFlag: this.setAiueoLineCode(this.sendData.furigana_last_name),
              searchFormType: this.$route.query.searchFormType,
            },
          });
        } else {
          if (this.fromHistoryDetails) {
            this.$router.push({
              path: '/historydetail',
              query: {
                CallSid: this.$route.query.CallSid,
                search_phonebook_name: this.$route.query.search_phonebook_name,
                search_agent_name: this.$route.query.search_agent_name,
                search_memo: this.$route.query.search_memo,
                start: this.$route.query.start,
                end: this.$route.query.end,
                type: this.$route.query.type,
                page: this.$route.query.page,
                search_phone_number: this.$route.query.search_phone_number,
                status: this.$route.query.status,
                agent_name: this.$route.query.agent_name,
              },
            });
          } else {
            this.$router.push({
              path: '/contactlist/detail',
              query: {
                contactID:
                  this.$route.query.contactID === this.sendData.phone_number
                    ? this.$route.query.contactID
                    : this.sendData.phone_number,
                wordFlag: this.setAiueoLineCode(this.sendData.furigana_last_name),
                searchFormType: this.$route.query.searchFormType,
              },
            });
          }
        }
      }
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    fetchContactDataHandler: async function (contactID) {
      await this.postRequest('/contactlist/getcontactdata', { contactID: contactID, companyID: this.selectedCompanyID })
        .then(e => {
          if (e.session) {
            this.setCurrentValue(e.data);
          } else {
            window.location.href = '/login';
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('連絡先情報取得'));
        });
    },

    /**
     *  #2121 パラメタで指定された名前かなのデータ(furigana_last_name)から連絡先一覧に返すリンク行のコード('1'-あ行,'2'-か行...)を返却する
     *  パラメタが無効な場合には'1'(あ行)を返す
     *  $param {string} nameKana - 氏名カナの文字列。furigana_last_nameを指定する
     *  $return {string} リンク行の有効なリンクを示すコード '1'-あ行,'2'-か行,,,etc
     */
    setAiueoLineCode(nameKana) {
      const lineRegexpList = [
        '^[ァ-オ].*',
        '^[カ-ゴヵヶ].*',
        '^[サ-ゾ].*',
        '^[タ-ド].*',
        '^[ナ-ノ].*',
        '^[ハ-ポ].*',
        '^[マ-モ].*',
        '^[ャ-ヨ].*',
        '^[ラ-ロ].*',
        '^[ヮ-ヴヷ-ヺ].*',
        '^[0-z０-９ー].*',
      ];
      if (!nameKana) {
        return '1';
      }
      for (let i = 0; i < lineRegexpList.length; i++) {
        const re = new RegExp(lineRegexpList[i], '');
        if (re.test(nameKana)) {
          return String(i + 1);
        }
      }
      return '1'; // 来ないはずだが念の為
    },
  },
};
</script>
